"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericModal = void 0;
const react_1 = __importDefault(require("react"));
const window_1 = require("../../contexts/window");
const constants_1 = require("../constants");
const i18n_1 = require("../../utils/i18n");
const controls_1 = require("../../components/controls");
const i18Next_1 = __importDefault(require("../../utils/i18Next"));
const GenericModal = ({ close, title, info, children, isInline, icon, align = 'center', padding, gap = 1, widthModal = "32rem", acceptClassNames = "btn btn-primary", cancelClassNames = "btn btn-secondary", textActionButton = i18Next_1.default.t('text.button.label.confirm.changes'), textCancelButton = i18Next_1.default.t('text.button.label.cancel'), handleAction, handleCancelAction = close(), }) => {
    const { isMobile } = (0, window_1.useWindow)();
    const widthStyles = { maxWidth: isMobile ? "30rem" : widthModal };
    const confirmationStyles = Object.assign(Object.assign(Object.assign({}, constants_1.messageStyles), widthStyles), { zIndex: 1046 });
    const titleStyle = { fontSize: isMobile ? '16px' : '22px', fontWeight: 'bold', margin: 0 };
    const modalBodyStyles = {
        textAlign: align,
    };
    const rowStyles = Object.assign({ alignItems: align, textAlign: align }, (!title && { justifyContent: align }));
    const handleCancel = () => {
        handleCancelAction && handleCancelAction();
    };
    const handleAccept = () => {
        handleAction && handleAction();
    };
    return (react_1.default.createElement("div", { className: "modal-general", style: confirmationStyles, onClick: (e) => e.stopPropagation() },
        react_1.default.createElement("div", { className: "modal-general-content", style: { padding } },
            react_1.default.createElement("div", { className: "modal-general-header", style: { paddingTop: "0px" } },
                react_1.default.createElement("div", { className: "modal-general-title" },
                    react_1.default.createElement("div", { className: `g-column-reverse ` },
                        react_1.default.createElement("div", { className: "col-md-12" },
                            react_1.default.createElement("div", { className: `g-column g-${gap}`, style: rowStyles },
                                icon,
                                react_1.default.createElement("p", { style: titleStyle }, title))),
                        react_1.default.createElement("div", { style: { alignContent: align, padding: 0 }, className: 'col-md-12' },
                            react_1.default.createElement("button", { className: "icon--close-circle close", onClick: close, "aria-label": (0, i18n_1.text)("popup.close") }))))),
            react_1.default.createElement("div", { className: "modal-general-body", style: modalBodyStyles }, children),
            react_1.default.createElement("div", { className: "modal-general-footer", style: { paddingTop: "0px" } },
                react_1.default.createElement("div", { className: `g-column `, style: { textAlign: align } },
                    react_1.default.createElement("div", { className: `${isInline ? `g-row-reverse ` : `g-column `}` },
                        react_1.default.createElement("div", { className: `col-md-12` },
                            react_1.default.createElement(controls_1.Button, { id: "confirmation-primary", classes: acceptClassNames, text: textActionButton, onClick: handleAccept })),
                        react_1.default.createElement("div", { className: `col-md-12` },
                            react_1.default.createElement(controls_1.Button, { id: "confirmation-secondary", classes: cancelClassNames, text: textCancelButton, onClick: handleCancel }))),
                    react_1.default.createElement("p", { style: { fontSize: '12px' } }, info))))));
};
exports.GenericModal = GenericModal;
